import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

function Register() {
  const navigate = useNavigate();
  const [emptyFirstNameError, setEmptyFirstNameError] = useState(false);
  const [emptyLastNameError, setEmptyLastNameError] = useState(false);
  const [emptyEmailError, setEmptyEmailError] = useState(false);
  const [registerError, setRegisterError] = useState(false);
  const emptyFieldError = "This field cannot be left empty.";
  const passwordFieldError = "The entered passwords do not match or one of the two fields was left empty."

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get('first_name').length === 0) {
        setEmptyFirstNameError(true);
    }
    else if (data.get('last_name').length === 0) {
        setEmptyLastNameError(true);
    }
    else if (data.get('email').length === 0) {
        setEmptyEmailError(true);
    }
    else if ((data.get('password') !== data.get('confirm_password')) || data.get('password').length === 0) {
        setRegisterError(true);
    }
    else {
        setEmptyFirstNameError(false);
        setEmptyLastNameError(false);
        setEmptyEmailError(false);
        setRegisterError(false);
        axios.post('/api/register',
            {
                first_name: data.get('first_name'),
                last_name: data.get('last_name'),
                email: data.get('email'),
                password: data.get('password'),
            }).then(function (response) {
            // console.log(response);
            if (response.status === 200) {
                // console.log(response);
                // Flash Success somehow
                navigate('/');
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.response.status === 401) {
                console.log('registration failed')
            }
        });
    }
  }

  return (
      <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <h2>RCP RGA Portal</h2>
          <Typography component="h1" variant="h5">
            Register
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
              margin="normal"
              required
              fullWidth
              id="first_name"
              label="First Name"
              name="first_name"
              error={emptyFirstNameError}
              helperText={emptyFirstNameError ? emptyFieldError : ""}
            />
              <TextField
              margin="normal"
              required
              fullWidth
              id="last_name"
              label="Last Name"
              name="last_name"
              error={emptyLastNameError}
              helperText={emptyLastNameError ? emptyFieldError : ""}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              error={emptyEmailError}
              helperText={emptyEmailError ? emptyFieldError : ""}
            />
              <TextField
              margin="normal"
              required
              fullWidth
              error={registerError}
              name="password"
              label="Password"
              type="password"
              id="password"
              helperText={registerError ? passwordFieldError : ""}
            />
              <TextField
              margin="normal"
              required
              fullWidth
              error={registerError}
              name="confirm_password"
              label="Confirm Password"
              type="password"
              id="confirm_password"
              helperText={registerError ? passwordFieldError : ""}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Register
            </Button>
          </Box>
      </Box>
  );
}

export default Register;